import { put, all, call, select } from 'redux-saga/effects'

import { FiscalInfo } from 'services/api/entities'
import api from 'app/services/api/api'
import { FiscalInfoActionCreators } from 'app/reducers/FiscalInfoRedux'

export function* generateInitialDocuments(params) {
  try {
    const response = yield FiscalInfo.generateInitialDocuments(params.data)
    
    if (response.success()) {
      yield put(FiscalInfoActionCreators.generateInitialDocumentsSuccess(response.data))
    } else {
      yield put(FiscalInfoActionCreators.generateInitialDocumentsFailure(response.data))
    }
  } catch (error) {
    console.error('Error generating initial documents:', error)
    yield put(FiscalInfoActionCreators.generateInitialDocumentsFailure({
      message: 'Error al generar los documentos. Por favor, inténtelo de nuevo.'
    }))
  }
}

export function* checkFiscalPermissions() {
  try {
    const token = yield select(state => state.auth.token)
    const response = yield call(api.privateGet, '/v1/contract_version/permissions/can_navigate/', { token })
    
    if (response.status === 200) {
      yield put(FiscalInfoActionCreators.checkFiscalPermissionsSuccess(response.data))
    } else {
      yield put(FiscalInfoActionCreators.checkFiscalPermissionsFailure(response.data))
    }
  } catch (error) {
    yield put(FiscalInfoActionCreators.checkFiscalPermissionsFailure({
      message: 'Error al verificar permisos fiscales. Se requiere completar la información.'
    }))
  }
}

export function* acceptContracts() {
  try {
    // Get the document names from the Redux state
    const documents = yield select(state => state.fiscalInfo.documents)
    
    if (!documents || Object.keys(documents).length === 0) {
      throw new Error('No documents found to accept')
    }
    
    const documentNames = Object.keys(documents)
    
    // Call the acceptance endpoint for each document
    const acceptanceResults = yield all(
      documentNames.map(documentName => 
        call(FiscalInfo.acceptDocument, documentName)
      )
    )
    
    // Check if all acceptances were successful
    const allSuccessful = acceptanceResults.every(response => response.success())
    
    if (allSuccessful) {
      yield put(FiscalInfoActionCreators.acceptContractsSuccess({
        message: 'Todos los contratos fueron aceptados exitosamente',
        acceptedDocuments: documentNames
      }))
    } else {
      const failedResponses = acceptanceResults.filter(response => !response.success())
      yield put(FiscalInfoActionCreators.acceptContractsFailure({
        message: 'Error al aceptar algunos contratos',
        failures: failedResponses.map(response => response.data)
      }))
    }
  } catch (error) {
    console.error('Error accepting contracts:', error)
    yield put(FiscalInfoActionCreators.acceptContractsFailure({
      message: 'Error al aceptar los contratos. Por favor, inténtelo de nuevo.',
      error: error.message
    }))
  }
}
